/* eslint-disable max-lines */
import store from '@/store/index';
import { allNumber } from '@/modules/mdm/utils/regList.js';
import configurl from '@/config/user.env';
const { user } = store.getters;
const setOwnerList = data => {
    if (!(Array.isArray(data) && data.length)) return {};
    const ownerNameObj = {};
    // eslint-disable-next-line no-unused-expressions
    data?.forEach((it, index) => {
        const ownerName = 'ownerName' + (index + 1);
        const ownerCode = 'ownerCode' + (index + 1);
        const ownerRatio = 'ownerRatio' + (index + 1);
        const ownerId = 'ownerId' + (index + 1);
        ownerNameObj[ownerName] = it.ownerName;
        ownerNameObj[ownerCode] = it.ownerCode;
        ownerNameObj[ownerRatio] = it.ownerRatio;
        ownerNameObj[ownerId] = it.id;
    });
    return ownerNameObj;
};
export const tableConfig = {
    name: 'customerPersonResponserEdit',
    searchFields: [
        {
            name: '客户',
            value: 'customerName',
            type: 'advanceMulti',
            advanceConfig: [
                { prop: 'customerName', value: '客户名称' },
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerGroupName', value: '客户系' }
            ],
            tableConfig: [
                { prop: 'customerName', value: '客户名称', 'displayName': 'customerName' },
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerGroupName', value: '客户系' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/customer/info/page',
            cbParams: ['customerCode', 'customerName'],
            beforeRequest: (params) => {
                params.userCode = user.userCode;
                return params;
            },
            isFixed: true,
            span: 2
        },

        {
            name: '分公司',
            value: 'companyName',
            type: 'advanceMulti',
            isFixed: true,
            span: 2,
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode', 'companyNameCn#companyName']
        },
        {
            name: '经营中心',
            value: 'businessCenterName',
            type: 'advanceMulti',
            isFixed: true,
            span: 2,
            advanceConfig: [
                { prop: 'businessCenterName', value: '经营中心名称' },
                { prop: 'businessCenterCode', value: '经营中心编码' }
            ],
            tableConfig: [
                { prop: 'businessCenterName', value: '经营中心名称', displayName: 'businessCenterName' },
                { prop: 'businessCenterCode', value: '经营中心编码' }
            ],
            prefix: '/api-lcs',
            advanceUrl: '/bid/queryCompanyByCodeAndName',
            cbParams: ['businessCenterCode', 'businessCenterName'],
            advanceCascade: 'companyCode#companyCode' // 关联入参只针对单选有效
        },
        {
            name: '分摊类型',
            value: 'respDivide',
            type: 'select',
            optionNum: 'NEOCRM_RESP_DIVIDE',
            isFixed: true,
            span: 2
        },
        {
            name: '责任人',
            prop: 'ownerName',
            type: 'advanceMulti',
            // maxNum: 10, // 多选条数限制
            isFixed: true,
            span: 3,
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            method: 'get',
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName', 'esusLoginName#ownerCode'],
            beforeRequest: (params) => {
                const inputKey = (params.userName ? params.userName : (params.userCode ? params.userCode : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.userName = inputKey;
                    params.userCode = null;
                } else {
                    params.userCode = inputKey;
                    params.userName = null;
                }
                params.applicant = user.userCode;
                params.status = '';
                return params;
            },
            record: true // 变更明细查询专属
        },
        {
            name: '生效日期',
            value: 'effectTime',
            isFixed: true,
            type: 'time',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            startPlaceholder: '生效日期从',
            endPlaceholder: '生效日期到',
            span: 4
        }
    ],
    selection: true,
    columns: [
        {
            label: '客户编码',
            prop: 'customerCode',
            width: 120
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 140
        },
        {
            label: '分公司',
            prop: 'companyName',
            width: 90
        },
        {
            label: '经营中心',
            prop: 'businessCenterName',
            width: 120
        },
        {
            label: '分摊类型',
            prop: 'respDivide',
            type: 'select',
            optionsKey: 'NEOCRM_RESP_DIVIDE'
        },
        {
            label: '主责任人1',
            prop: 'ownerName1',
            value: 'ownerName1',
            name: '添加责任人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName1', 'esusLoginName#ownerCode1'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 140
        },
        {
            label: '主责任人比例1',
            prop: 'ownerRatio1',
            type: 'input',
            verify: allNumber,
            width: 110

        },
        {
            label: '责任人2',
            prop: 'ownerName2',
            value: 'ownerName2',
            name: '添加责任人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName2', 'esusLoginName#ownerCode2'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 140
        },
        {
            label: '责任人比例2',
            prop: 'ownerRatio2',
            type: 'input',
            verify: allNumber,
            width: 110

        },
        {
            label: '责任人3',
            prop: 'ownerName3',
            value: 'ownerName3',
            name: '添加责任人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName3', 'esusLoginName#ownerCode3'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 140
        },
        {
            label: '责任人比例3',
            prop: 'ownerRatio3',
            type: 'input',
            verify: allNumber,
            width: 110
        },
        {
            label: '责任人4',
            prop: 'ownerName4',
            value: 'ownerName4',
            name: '添加责任人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName4', 'esusLoginName#ownerCode4'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 140
        },
        {
            label: '责任人比例4',
            prop: 'ownerRatio4',
            verify: allNumber,
            type: 'input',
            width: 110
        },
        {
            label: '责任人5',
            prop: 'ownerName5',
            value: 'ownerName5',
            name: '添加责任人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName5', 'esusLoginName#ownerCode5'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 140
        },
        {
            label: '责任人比例5',
            prop: 'ownerRatio5',
            type: 'input',
            verify: allNumber,
            width: 110
        },
        {
            label: '行业公共池比例',
            prop: 'industryCommonPoolRatio',
            type: 'input',
            placeholder: '行业公共池比例',
            width: 110
        },
        {
            label: '分公司公共池比例',
            prop: 'companyCommonPoolRatio',
            type: 'input',
            width: 120
        },
        {
            label: '生效日期',
            prop: 'effectStartTime',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            // pickerOptions: effectDisabledDate(),
            mustFill: true,
            width: 160
        },
        {
            label: '失效日期',
            prop: 'effectEndTime',
            width: 120
        },
        {
            label: '变更前',
            prop: 'historicalState',
            width: 120
        },
        {
            label: '关联单据号',
            prop: 'relationId'
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 120, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '保存',
                event: 'save',
                displayRule: (row) => {
                    return +row.edit === 2;
                }
            },
            {
                label: '删除',
                event: 'del',
                displayRule: (row) => {
                    return true;
                }
            }
        ]
    },
    importConfig: {
        action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
        multiple: false,
        accept: 'xlsx',
        showFileList: false,
        fileType: '只能上传Excel文件',
        manualUpload: true
    },
    contractAdvanceParams: {
        advanceLabel: '选取需要变更的提成分配规则',
        dialogWidth: '1300px',
        deleteOtherProp: true,
        advanceConfig: [
            {
                name: '单据号',
                value: '单据号',
                prop: 'id',
                type: 'input',
                span: 1
            },
            {
                name: '客户系',
                prop: 'customerGroupName',
                value: 'customerGroupName',
                type: 'advanceMulti',
                isFixed: false,
                span: 3,
                advanceConfig: [
                    { prop: 'customerGroupName', value: '客户系名称' },
                    { prop: 'customerGroupCode', value: '客户系编码' }
                ],
                tableConfig: [
                    { prop: 'customerGroupCode', value: '客户系编码' },
                    { prop: 'customerGroupName', value: '客户系名称', 'displayName': 'customerGroupName' }
                ],
                prefix: '/api-lcrm',
                advanceUrl: '/customer/group/info/page',
                cbParams: ['customerGroupCode', 'customerGroupName'],
                advanceCode: 'advanceCode'
            },
            //
            {
                name: '客户',
                value: 'customerName',
                prop: 'customerName',
                type: 'advanceMulti',
                advanceConfig: [
                    { prop: 'customerName', value: '客户名称' },
                    { prop: 'customerCode', value: '客户编码' },
                    { prop: 'customerGroupName', value: '客户系' }
                ],
                tableConfig: [
                    { prop: 'customerName', value: '客户名称', 'displayName': 'customerName' },
                    { prop: 'customerCode', value: '客户编码' },
                    { prop: 'customerGroupCode', value: '客户系' }
                ],
                method: 'post',
                prefix: '/api-lcrm',
                advanceUrl: '/customer/info/page',
                cbParams: ['customerCode', 'customerName'],
                beforeRequest: (params) => {
                    params.userCode = user.userCode;
                    return params;
                },
                isFixed: true,
                span: 3
            },
            {
                name: '分公司',
                prop: 'companyName',
                value: 'companyName',
                type: 'advanceMulti',
                isFixed: true,
                span: 2,
                advanceConfig: [
                    { 'prop': 'companyNameCn', 'value': '分公司名称' },
                    { 'prop': 'companyCode', 'value': '分公司编码' }
                ],
                tableConfig: [
                    { 'prop': 'companyCode', 'value': '分公司编码' },
                    { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' }
                ],
                prefix: '/api-mdm',
                advanceUrl: `/esCompany/popCompany`,
                cbParams: ['companyCode', 'companyNameCn#companyName']
            },
            {
                name: '经营中心',
                prop: 'businessCenterName',
                value: 'businessCenterName',
                type: 'advanceMulti',
                isFixed: true,
                span: 2,
                advanceConfig: [
                    { prop: 'businessCenterName', value: '经营中心名称' },
                    { prop: 'businessCenterCode', value: '经营中心编码' }
                ],
                tableConfig: [
                    { prop: 'businessCenterName', value: '经营中心名称', displayName: 'businessCenterName' },
                    { prop: 'businessCenterCode', value: '经营中心编码' }
                ],
                prefix: '/api-lcs',
                advanceUrl: '/bid/queryCompanyByCodeAndName',
                cbParams: ['businessCenterCode', 'businessCenterName'],
                advanceCascade: 'companyCode#companyCode' // 关联入参只针对单选有效
            },
            {
                name: '责任人',
                value: 'ownerName',
                prop: 'ownerName',
                type: 'advanceMulti',
                // maxNum: 10, // 多选条数限制
                isFixed: true,
                span: 3,
                advanceConfig: [
                    { 'prop': 'esusUserNameCn', 'value': '姓名' },
                    { 'prop': 'esusLoginName', 'value': '美信号' }
                ],
                tableConfig: [
                    { 'prop': 'esusLoginName', 'value': '美信号' },
                    { 'prop': 'esusUserNameCn', 'value': '姓名', displayName: 'esusUserNameCn' },
                    { 'prop': 'esusPositionName', 'value': '职位' },
                    { 'prop': 'escoCompanyNameCn', 'value': '部门' }
                ],
                method: 'get',
                prefix: '/api-mdm',
                advanceUrl: `/selectUserCompany`,
                cbParams: ['esusUserNameCn#ownerName', 'esusLoginName#ownerCode'],
                beforeRequest: (params) => {
                    const inputKey = (params.userName ? params.userName : (params.userCode ? params.userCode : '')).trim();
                    const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                    if (reg.test(inputKey)) {
                        params.userName = inputKey;
                        params.userCode = null;
                    } else {
                        params.userCode = inputKey;
                        params.userName = null;
                    }
                    params.applicant = user.userCode;
                    params.status = '';
                    return params;
                },
                record: true // 变更明细查询专属
            },
            {
                name: '维护状态',
                value: '维护状态',
                prop: 'maintainStatusList',
                type: 'select',
                optionsKey: 'MAINTAIN_STATUS_PART',
                multiple: false,
                span: 3
            },
            {
                name: '单据所在部门',
                value: 'billDepartmentName',
                prop: 'billDepartmentName',
                type: 'advanceMulti',
                // maxNum: 10, // 多选条数限制
                isFixed: false,
                span: 3,
                advanceConfig: [
                    { 'prop': 'departmentName', 'value': '所在部门名称' },
                    { 'prop': 'departmentCode', 'value': '所在部门编码' }
                ],
                tableConfig: [
                    { 'prop': 'departmentCode', 'value': '所在部门编码' },
                    { 'prop': 'departmentName', 'value': '所在部门名称', 'displayName': 'departmentName' }
                ],
                method: 'post',
                prefix: '/api-lcrm',
                advanceUrl: `/customer/manager/archive/billDepartment/collect`,
                cbParams: ['departmentCode#billDepartmentCode', 'departmentName#billDepartmentName']
            },
            {
                name: '行业',
                value: '行业',
                prop: 'industryCategoriesCodeList',
                type: 'select',
                multiple: true,
                optionsKey: 'SYS_SUPPLIER_INDUSTRY',
                isFixed: false,
                span: 3
            }

        ],
        beforeRequest: (params) => {
            return params;
        },
        afterResponse: (res) => {
            if (res && +res.code === 0) {
                res.data.list = res.data.list.map(it => {
                    return {
                        ...it,
                        ...setOwnerList(it.ownerList)
                    };
                });
            }
            return res;
        },
        tableConfig: [
            { 'prop': 'id', 'value': '单据号', width: '70px' },
            { 'prop': 'maintainStatus', 'value': '状态', width: '50px', type: 'select', optionsKey: 'MANAGER_ARCHIVE_MAINTAIN_STATUS' },
            { 'prop': 'customerName', 'value': '客户名称', width: '150px', 'displayName': 'customerName' },
            { 'prop': 'companyName', 'value': '分公司', width: '100px' },
            { 'prop': 'businessCenterName', 'value': '经营中心', width: '130px' },
            { 'prop': 'industryCategoriesName', 'value': '行业', width: '50px' },
            { 'prop': 'respDivide', 'value': '分摊类型', width: '50px', type: 'select', optionsKey: 'NEOCRM_RESP_DIVIDE' },
            { 'prop': 'customerGroupCode', 'value': '客户系', width: '60px', type: 'select', optionsKey: 'SYS_CUST_RELATION_TYPE' },
            {
                'prop': 'calCustomerLevelCode', 'value': '客户等级', width: '50px', type: 'select', optionsKey: 'NEOCRM_CUSTOMER_LEVEL'
            },
            { 'prop': 'ownerName1', 'value': '主责任人' },
            { 'prop': 'ownerRatio1', 'value': '主责任人比例', width: '100px' },
            { 'prop': 'ownerName2', 'value': '主责任人2' },
            { 'prop': 'ownerRatio2', 'value': '主责任人比例2', width: '110px' },
            { 'prop': 'ownerName3', 'value': '主责任人3' },
            { 'prop': 'ownerRatio3', 'value': '主责任人比例3', width: '110px' },
            { 'prop': 'ownerName4', 'value': '主责任人4' },
            { 'prop': 'ownerRatio4', 'value': '主责任人比例4', width: '110px' },
            { 'prop': 'ownerName5', 'value': '主责任人5' },
            { 'prop': 'ownerRatio5', 'value': '主责任人比例5', width: '110px' },
            { 'prop': 'billOwnerName', 'value': '单据所有人', width: '100px' },
            { 'prop': 'billDepartmentName', 'value': '单据所在部门', width: '100px' }
        ],
        multipleFilterItem: 'contractCode',
        // eslint-disable-next-line no-magic-numbers
        pageSizes: [10, 20, 30, 50, 100],
        newMultiple: true, // 多选
        prefix: 'api-lcrm',
        border: true,
        method: 'post',
        searchType: 'input',
        advanceUrl: '/customer/manager/archive/page/auth',
        cbParams: ['id', 'industryCategoriesName', 'calCustomerLevelCode', 'respDivide', 'customerName', 'customerCode', 'billDepartmentCode', 'billDepartmentName',
            'billSource', 'billSourceRemark', 'billOwnerCode', 'billOwnerName', 'customerLevelCode', 'industryType', 'businessCenterName', 'businessCenterCode',
            'respDivide', 'ownerName1', 'ownerRatio1', 'ownerName2', 'ownerRatio2', 'ownerName3', 'ownerRatio3', 'ownerName4', 'ownerRatio4', 'ownerName5', 'ownerRatio5',
            'companyCommonPoolRatio', 'industryCommonPoolRatio', 'effectStartTime', 'effectEndTime', 'ownerList#ownerFlowList', 'historicalState', 'customerGroupCode',
            'companyCode', 'companyName'
        ],
        hideTooltip: true
    }
};
